
if (!window.fwLaunchInstalled) {
  window.fwLaunchInstalled = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fw-launch-form]');
    if (trigger) {
      const dialog = Array.from(trigger.closest('.fw-upcoming').querySelectorAll('dialog')).find(el => el.querySelector('[data-forms-id]')?.getAttribute('data-forms-id') === 'forms-root-' + trigger.dataset.fwLaunchForm);
      if (!dialog || !dialog.showModal) return;
      event.preventDefault();
      dialog.showModal();
      return;
    }
    const close = event.target.closest('.fw-launch-close');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.fw-launch-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
}
